import { useState } from 'react';
import styled from 'styled-components';
import { Tooltip, ClickAwayListener } from '@material-ui/core';
import { Flex } from 'components/base/layout-components';
import { resetTooltipStyleClassesForDatePicker } from '../Tooltips/helpers';
import { PERIODS } from './periods/constants';
import PeriodsMenu from './components/PeriodsMenu';
import PeriodSelected from './components/PeriodSelected';
import PeriodSelection from './components/PeriodsSelection/PeriodsSelection';
import BrowserStorageAccessor from 'common/utils/BrowserStorageAccessor';
import { SESSION_STORAGE_KEYS } from 'common/constants/constants';

const StyledPeriodSelectedWrapper = styled(Flex)`
  position: relative;
`;

const StyledPeriodsMenuWrapper = styled(Flex)`
  display: flex;
  overflow: auto;
  padding: 1.5rem;
  min-height: 35.3rem;
`;

const PeriodPicker = ({
  currentPeriod,
  disabledPeriods = [],
  onChange,
  size = 'medium',
  width,
  showCalendarIcon = false,
  disabled,
  hiddenPeriods = [],
  isCustomDateOutsideRange,
  show30daysMessage
}) => {
  const sessionStorageAccessor = BrowserStorageAccessor().session;

  const { periodKey = PERIODS.DEFAULT_PERIOD } = currentPeriod;
  const periodProps = PERIODS[periodKey];
  const [open, setOpen] = useState(false);
  const [selectedPeriod, setSelectedPeriod] = useState(null);

  const openMenu = () => {
    if (disabled) {
      return;
    }

    setSelectedPeriod({
      ...currentPeriod,
      ...periodProps
    });
    setOpen(true);
    document.getElementsByTagName('body')[0].style.overflow = 'hidden';
  };

  const closeMenu = () => {
    setOpen(false);
    document.getElementsByTagName('body')[0].style.overflow = 'unset';
  };

  return (
    <Tooltip
      interactive
      open={open}
      placement='bottom-start'
      classes={resetTooltipStyleClassesForDatePicker()}
      title={
        <ClickAwayListener onClickAway={closeMenu}>
          <StyledPeriodsMenuWrapper data-cy='period-picker-menu'>
            <PeriodsMenu
              disabledPeriods={disabledPeriods}
              selectedPeriod={selectedPeriod}
              setSelectedPeriod={setSelectedPeriod}
              hiddenPeriods={hiddenPeriods}
            />
            <PeriodSelection
              selectedPeriod={selectedPeriod}
              onChange={selectedPeriod => {
                onChange(selectedPeriod);
                sessionStorageAccessor.set(
                  SESSION_STORAGE_KEYS.SELECTED_PERIOD,
                  JSON.stringify(selectedPeriod)
                );
                closeMenu();
              }}
              isCustomDateOutsideRange={isCustomDateOutsideRange}
            />
          </StyledPeriodsMenuWrapper>
        </ClickAwayListener>
      }
    >
      <StyledPeriodSelectedWrapper width={width} items='center'>
        <PeriodSelected
          currentPeriod={currentPeriod}
          open={open}
          openMenu={openMenu}
          size={size}
          width={width}
          showCalendarIcon={showCalendarIcon}
          disabled={disabled}
          show30daysMessage={show30daysMessage}
        />
      </StyledPeriodSelectedWrapper>
    </Tooltip>
  );
};

export default PeriodPicker;
